import { useState } from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { locale, setLocale, locales } = useI18n();
  const [open, setOpen] = useState(false);
  const active = locales.find((l) => l.code === locale) || locales[0];

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        data-testid="language-switcher-btn"
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="flex items-center gap-2 px-2.5 py-2 border border-slate-800 hover:border-[#1E3A8A] bg-[#0F172A] rounded-sm transition-colors"
      >
        <Globe className="w-3.5 h-3.5 text-slate-400" />
        <span className="text-[11px] font-mono font-bold tracking-wider text-slate-200">{active.short}</span>
      </button>
      {open && (
        <div className="absolute top-full mt-1 left-0 w-44 border border-slate-800 bg-[#0F172A] rounded-sm shadow-2xl z-50" data-testid="language-dropdown">
          {locales.map((l) => (
            <button
              key={l.code}
              data-testid={`language-option-${l.code}`}
              onMouseDown={(e) => { e.preventDefault(); setLocale(l.code); setOpen(false); }}
              className={`w-full text-left px-3 py-2 text-xs hover:bg-[#1E293B] border-b border-slate-800/60 flex items-center justify-between ${
                locale === l.code ? "bg-[#1E3A8A]/15 text-white" : "text-slate-300"
              }`}
            >
              <span>
                <span className="font-mono font-bold mr-2">{l.short}</span>
                <span className="text-slate-400">{l.label}</span>
              </span>
              {locale === l.code && <Check className="w-3 h-3 text-emerald-400" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
